import { inject, injectable } from 'inversify'
import {
  IAppErrorFactory,
  IRemoveExperienceUseCase,
  IViewerService,
  RemoveExperienceUseCaseInput,
  RemoveExperienceUseCaseOutput,
} from '@/types'
import symbols from '@/symbols'

@injectable()
export default class RemoveExperienceInteractor implements IRemoveExperienceUseCase {
  @inject(symbols.IViewerService) private viewerService: IViewerService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: RemoveExperienceUseCaseInput): Promise<RemoveExperienceUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.experience = await this.viewerService.removeExperience(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: '経歴情報の削除に失敗しました',
      })
    }

    return output
  }

  private getDefaultOutputData(): RemoveExperienceUseCaseOutput {
    return {
      experience: null,
      error: null,
    }
  }
}
